import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'eddydata-lib';
import { InventarioSecretariaRptComponent } from './inventario-secretaria-rpt.component';

const routes: Routes = [
  { path: '', component: InventarioSecretariaRptComponent, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InventarioSecretariaRptRoutingModule { }
